import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import { getKhattabaAiStore } from "../../../../stores/khattabat-stores/ai-stores/khattaba-ai-store";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";

const KhattabatSelects = withLiteObserverAndTheme(() => {
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();
  const { isSelectedAll, toggleAllMarksStates, selectedCount } =
    getKhattabatSelectsStore();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%" }}
    >
      {isAiKhattaba ? (
        <Typography fontWeight={fontWeights.semibold}>
          {`${i18n.get("COUNT")}: ${getKhattabaAiStore().getClientsCount.get()}`}
        </Typography>
      ) : (
        <>
          <FormControlLabel
            label={i18n.get("SELECT_ALL")}
            control={
              <Checkbox
                color="success"
                checked={isSelectedAll("clientPage")}
                onChange={() => toggleAllMarksStates("clientPage")}
              />
            }
          />
          <Typography fontWeight={fontWeights.semibold}>
            {`${i18n.get("COUNT_SELECTED")}: ${selectedCount.get()}`}
          </Typography>
        </>
      )}
    </Stack>
  );
});

export default KhattabatSelects;
